import AddNew from "./AddNew";
import Customers from "./Customers";

export default { AddNew, Customers };



// WEBPACK FOOTER //
// ./src/components/customers/index.js